import './UserSettings.scss';
import { AccountInformation } from './AccountInformation';
import { ChangePassword } from './ChangePassword';
import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { CurrentUserEmail } from './Email';
import { EditAvatar } from './EditAvatar';
import { PreferenceToggles } from './PreferenceToggles';
import React from 'react';
import { Col, Row } from 'antd';
import { SonarCard, ViewArea } from '@ui/general';
export const UserSettings = () => React.createElement(ViewArea, { direction: 'vertical', fullWidth: true, id: 'user-settings' },
    React.createElement(SonarCard, { title: COPY_SPECIFIC.USER_SETTINGS },
        React.createElement(Row, null,
            React.createElement(Col, null,
                React.createElement(EditAvatar, null)),
            React.createElement(Col, { className: 'settings-panel' },
                React.createElement(CurrentUserEmail, null),
                React.createElement(AccountInformation, null),
                React.createElement(PreferenceToggles, null),
                React.createElement(ChangePassword, null)))));
